module.exports = __webpack_public_path__ + "img/305ae86.png";